var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "table", staticClass: "gobierto-table" },
    [
      _vm.showColumnSelector
        ? [
            _vm._t("columns", [
              _c(
                "div",
                { staticClass: "gobierto-table__header" },
                [
                  _c("TableColumnsSelector", {
                    attrs: { columns: _vm.mapColumns },
                    on: { "visible-columns": _vm.filterColumns }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("table", [
        _c(
          "thead",
          [
            _vm._l(_vm.arrayColumnsFiltered, function(ref) {
              var id = ref[0]
              var ref_1 = ref[1]
              var name = ref_1.name
              var index = ref_1.index
              var cssClass = ref_1.cssClass
              return [
                _c(
                  "th",
                  {
                    key: index,
                    staticClass: "gobierto-table__th",
                    class: cssClass,
                    on: {
                      click: function($event) {
                        return _vm.handleTableHeaderClick(id)
                      }
                    }
                  },
                  [
                    _vm._v("\n          " + _vm._s(name) + "\n          "),
                    _vm.currentSortColumn === id
                      ? _c("SortIcon", {
                          attrs: { direction: _vm.getSorting(id) }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.visibleRows, function(item, index) {
              return [
                _c(
                  "tr",
                  {
                    key: index,
                    staticClass: "gobierto-table__tr",
                    class: { "is-clickable": _vm.hasPermalink }
                  },
                  [
                    _vm._l(_vm.arrayColumnsFiltered, function(ref) {
                      var id = ref[0]
                      var ref_1 = ref[1]
                      var type = ref_1.type
                      var cssClass = ref_1.cssClass
                      return [
                        type === "money"
                          ? [
                              _c(
                                "td",
                                {
                                  key: id,
                                  staticClass: "gobierto-table__td",
                                  class: cssClass
                                },
                                [
                                  _vm.hasPermalink
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "gobierto-table__a",
                                            attrs: { href: item[_vm.href] },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.handleTableItem(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("money")(item[id])
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("money")(item[id])
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                            ]
                          : type === "date"
                          ? [
                              _c(
                                "td",
                                {
                                  key: id,
                                  staticClass: "gobierto-table__td",
                                  class: cssClass
                                },
                                [
                                  _vm.hasPermalink
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "gobierto-table__a",
                                            attrs: { href: item[_vm.href] },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.handleTableItem(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("date")(item[id])
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm._f("date")(item[id])) +
                                              "\n                  "
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                            ]
                          : type === "truncate"
                          ? [
                              _c(
                                "td",
                                { key: id, staticClass: "gobierto-table__td" },
                                [
                                  _vm.hasPermalink
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "gobierto-table__a",
                                            class: cssClass,
                                            attrs: { href: item[_vm.href] },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.handleTableItem(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item[id]) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c("span", { class: cssClass }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item[id]) +
                                              "\n                  "
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                            ]
                          : [
                              _c(
                                "td",
                                {
                                  key: id,
                                  staticClass: "gobierto-table__td",
                                  class: cssClass
                                },
                                [
                                  _vm.hasPermalink
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "gobierto-table__a",
                                            attrs: { href: item[_vm.href] },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.handleTableItem(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item[id]) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item[id]) +
                                              "\n                  "
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                            ]
                      ]
                    })
                  ],
                  2
                )
              ]
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.showPagination
        ? [
            _vm._t(
              "pagination",
              [
                _c("Pagination", {
                  attrs: {
                    data: _vm.rowsSorted,
                    "items-per-page": 25,
                    "container-pagination": "main"
                  },
                  on: { showData: _vm.updateData }
                })
              ],
              { paginator: _vm.updateData, data: _vm.rowsSorted }
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }